import React, { useState } from 'react';
import './Login.css';
import { Link, useHistory } from "react-router-dom";
import { auth } from "./firebase";
import logo from './logo.png';
import { Form, Input, Button, Typography, Checkbox, Row, Col, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

function Copyright(props) {
  return (
    <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginTop: '40px' }} {...props}>
      Created by Ghilas Belkaci.
    </Text>
  );
}

function Login() {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onFinish = (values) => {
        setLoading(true);
        setError('');
        
        auth
            .signInWithEmailAndPassword(values.email, values.password)
            .then(auth => {
                history.push('/');
            })
            .catch(error => {
                setError(error.message);
                setLoading(false);
            });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '100vh', paddingTop: '80px', background: 'var(--bg-layout)' }}>
            <Link to="/" style={{ marginBottom: '40px' }}>
                <img className="header__logo" src={logo} alt="Vectacore Logo" style={{ height: '40px', objectFit: 'contain' }} />
            </Link>
            
            <div style={{ width: '100%', maxWidth: '360px', background: 'var(--bg-glass)', padding: '40px', borderRadius: '8px', border: '1px solid var(--border-glass)', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                <Title level={3} style={{ textAlign: 'center', marginBottom: '24px' }}>
                    Login
                </Title>
                
                {error && <Alert message={error} type="error" showIcon style={{ marginBottom: '24px' }} />}
                
                <Form
                    name="normal_login"
                    className="login-form"
                    layout="vertical"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="email"
                        rules={[{ required: true, message: 'Please input your Email!' }]}
                    >
                        <Input 
                            prefix={<UserOutlined className="site-form-item-icon" />} 
                            placeholder="Email Address" 
                            size="large" 
                        />
                    </Form.Item>
                    
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please input your Password!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="Password"
                            size="large"
                        />
                    </Form.Item>
                    
                    <Form.Item>
                        <Form.Item name="remember" valuePropName="checked" noStyle>
                            <Checkbox>Remember me</Checkbox>
                        </Form.Item>

                        <a className="login-form-forgot" href="#" style={{ float: 'right' }}>
                            Forgot password?
                        </a>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button" block size="large" loading={loading}>
                            Log in
                        </Button>
                    </Form.Item>
                    
                    <Row style={{ marginTop: '16px', textAlign: 'center' }}>
                        <Col span={24}>
                            <Link to="/signup">
                                Don't have an account? Sign Up
                            </Link>
                        </Col>
                    </Row>
                </Form>
            </div>
            
            <Copyright />
        </div>
    )
}

export default Login;

